import React from 'react';
import { useData, useStatus, isNormal } from 'resift';
import GlobalConfigContext from 'helpers/GlobalConfigContext';

import makeGlobalConfigFetch from 'store/configuration/actions/globalConfigFetch';

interface Props {
  children: React.ReactNode;
}

function GlobalConfigProvider({ children }: Props) {
  const globalConfigFetch = makeGlobalConfigFetch();

  const globalConfig = useData(globalConfigFetch);
  const status = useStatus(globalConfigFetch);

  if (!isNormal(status)) {
    throw new Error(
      '[GlobalConfigProvider] global config fetch status was not normal. Ensure this provider is placed below the AppFetches component',
    );
  }

  if (!globalConfig) {
    throw new Error('[GlobalConfigProvider] global config was falsy');
  }

  return (
    <GlobalConfigContext.Provider value={globalConfig}>{children}</GlobalConfigContext.Provider>
  );
}

export default GlobalConfigProvider;
